"use client";

import React, { useEffect, useState } from "react";
import { UserX } from "lucide-react";

import { ACCOUNT_DELETED_EVENT } from "@/lib/auth/account-deleted";

const COUNTDOWN_SECONDS = 10;

const AccountDeletedModal: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    const handler = () => {
      setSecondsLeft(COUNTDOWN_SECONDS);
      setVisible(true);
    };
    window.addEventListener(ACCOUNT_DELETED_EVENT, handler);
    return () => window.removeEventListener(ACCOUNT_DELETED_EVENT, handler);
  }, []);

  useEffect(() => {
    if (!visible) return;

    if (secondsLeft <= 0) {
      window.location.href = "/auth";
      return;
    }

    const timer = setTimeout(() => setSecondsLeft((value) => value - 1), 1000);
    return () => clearTimeout(timer);
  }, [visible, secondsLeft]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[220] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl dark:bg-gray-900">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/40">
          <UserX size={32} className="text-red-600 dark:text-red-400" />
        </div>
        <h2 className="mb-3 text-lg font-bold text-gray-900 dark:text-white">حساب کاربری شما حذف شده است</h2>
        <p className="mb-2 text-sm leading-7 text-gray-600 dark:text-gray-300">
          حساب کاربری شما توسط مدیریت حذف شده و از این پس امکان ورود و استفاده از آن وجود ندارد.
        </p>
        <p className="mb-6 text-sm leading-7 text-gray-600 dark:text-gray-300">
          اگر فکر می‌کنید این اقدام به اشتباه انجام شده، با پشتیبانی ترندی اسمارت تماس بگیرید.
        </p>
        <p className="text-xs font-medium text-gray-500 dark:text-gray-400">
          انتقال خودکار به صفحه ورود تا {secondsLeft.toLocaleString("fa-IR")} ثانیه دیگر...
        </p>
      </div>
    </div>
  );
};

export default AccountDeletedModal;
